// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"592":"common","966":"dashboard"}[chunkId] + "." + {"592":"14aae848","966":"81958a49"}[chunkId] + ".css";
};